import React from 'react';
import { statusList } from '../../../../data/statusOptions';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { setOpenModal } from '../../store/controlPanelSlice';
import { changeStatus } from '../../store/controlPanelThunks.js';
import "./StatusSelector.css";

const iconPath = (iconName) =>
    require(`../../../../assets/status_icon/${iconName}.png`);


/**
 * A component to display a list of selectable status icons.
 */
const StatusSelector = () => {

    const dispatch = useDispatch();
    const { t } = useTranslation();

    const onSelectStatus = (statusValue) => {
        dispatch(setOpenModal(""))
        dispatch(changeStatus({
                    body: {
                        status: statusValue
                    }
                }));
    }

    return (
        <ul className="icons-status">
            {statusList.map((status) => {
                // Destructure for cleaner access to status properties
                const { value, type, IconComponent, color, iconName, labelKey } = status;

                return (
                    <li
                        key={value}
                        className="status-icon-item"
                        onClick={() => onSelectStatus(value)}
                        title={()=> t(labelKey)} 
                    >
                        {type === 'mui' ? (
                            <IconComponent
                                sx={{
                                    color: color,
                                    width: "2.25rem",
                                    height: "2.25rem"
                                }}
                            />
                        ) : (
                            <img
                                src={iconPath(iconName)}
                                alt={labelKey}
                                style={{ width: '2.25rem', height: '2.25rem' }}
                            />
                        )}
                    </li>
                );
            })}
        </ul>
    );
};

export default StatusSelector;